import "./main.css";
export default function Main({ children }: { children: React.ReactNode }) {
  return <main>{children}</main>;
}
